import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "modalRfb",
  class: "modal fade",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "modalRfbMessage",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog text-start" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-body py-4" }
const _hoisted_5 = { class: "modal-footer border-top-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h1", {
            id: "modalRfbMessage",
            class: "modal-title fs-5"
          }, " Informações sobre a empresa "),
          _createElementVNode("button", {
            class: "btn-close",
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Fechar"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "fs-6" }, "Legal! Seu novo Certificado será para sua empresa!", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "fs-6" }, " Para qual CNPJ você deseja emitir este Certificado? ", -1)),
          _createVNode(_component_Input, {
            modelValue: _ctx.model.cnpj,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.cnpj) = $event)),
            label: "CNPJ",
            icon: "building",
            placeholder: "Digite apenas números",
            "is-numeric": "",
            mask: ['##.###.###/####-##', ''],
            "error-log": _ctx.error
          }, null, 8, ["modelValue", "error-log"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn modal-footer_btn-process btn-primary",
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleNextStep && _ctx.handleNextStep(...args)))
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "me-2" }, "Avançar", -1)),
            _createVNode(_component_Icon, { name: "arrow-right" })
          ])
        ])
      ])
    ])
  ]))
}